import { createStyles, WithStyles } from '@material-ui/core';
import LinearProgress, { LinearProgressProps } from '@material-ui/core/LinearProgress';
import { Theme, withStyles } from '@material-ui/core/styles';
import React from 'react';

// The types here seem to be composed a bit out of order wrt `withStyles`, in
// that it's only used for `LinearProgressBar`, not `ProgressBar` so I'm
// uncertain of where/how `classes` comes from without further digging
// eslint-disable-next-line @typescript-eslint/no-use-before-define
export interface ProgressBarProps extends WithStyles<typeof styles> {
  value: number;
  customColor?: string;
}

const progressBarColor = (theme: Theme, { value, customColor }: ProgressBarProps) => {
  const {
    palette: {
      common: { blue400, gray400 },
    },
  } = theme;

  if (customColor) {
    return customColor;
  }
  if (value <= 100) {
    return blue400;
  }

  return gray400;
};

const styles = (theme: Theme) =>
  createStyles({
    bar: {
      backgroundColor: (props: ProgressBarProps) => progressBarColor(theme, props),
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: theme.palette.common.gray200,
    },
    root: {
      borderRadius: 5,
      height: 6,
    },
  });

const LinearProgressBar = withStyles(styles)(
  ({ customColor, ...rest }: ProgressBarProps & Partial<LinearProgressProps>): JSX.Element => (
    <LinearProgress {...rest} />
  ),
);

const ProgressBar = ({ value, customColor, classes }: ProgressBarProps): JSX.Element => (
  <LinearProgressBar
    classes={classes}
    customColor={customColor}
    value={value > 100 ? 100 : value}
    variant="determinate"
  />
);

export default ProgressBar;
